module.exports = __webpack_public_path__ + "img/wyb@3x.107aa7e9.png";